var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9564 2.68957C13.0446 2.82819 12.8936 2.98966 12.7334 2.95325C12.42 2.85992 12.0734 2.81325 11.72 2.81325H9.60306C9.44585 2.81325 9.29779 2.73931 9.20334 2.61362L8.48668 1.65992C8.39278 1.52688 8.48154 1.33325 8.64438 1.33325H10.48C11.5207 1.33325 12.4374 1.87374 12.9564 2.68957Z",
    fill: "#8BABF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4266 4.35992C13.14 4.15325 12.8133 3.99992 12.46 3.91325C12.22 3.84659 11.9733 3.81325 11.72 3.81325H9.23998C8.85331 3.81325 8.82665 3.77992 8.61998 3.50659L7.68665 2.26659C7.25331 1.68659 6.91331 1.33325 5.82665 1.33325H4.27998C2.65331 1.33325 1.33331 2.65325 1.33331 4.27992V11.7199C1.33331 13.3466 2.65331 14.6666 4.27998 14.6666H11.72C13.3466 14.6666 14.6666 13.3466 14.6666 11.7199V6.75992C14.6666 5.76659 14.18 4.89325 13.4266 4.35992ZM9.59331 10.8933H6.39998C6.13998 10.8933 5.93998 10.6866 5.93998 10.4266C5.93998 10.1733 6.13998 9.95992 6.39998 9.95992H9.59331C9.85331 9.95992 10.06 10.1733 10.06 10.4266C10.06 10.6866 9.85331 10.8933 9.59331 10.8933Z",
    fill: "#8BABF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIc);
export default __webpack_public_path__ + "static/media/folder-ic.9cefb488cbf230944fc8a22d700d512a.svg";
export { ForwardRef as ReactComponent };